import { OmyConst } from "../OmyConst";
import Omy from "../Omy";
import POEditor from "../../plugin/POEditor";
import StringUtils from "../utils/StringUtils";

export default class Localization {
    constructor() {
        this._locAtlasList = [];
        this._locAtlasNamesList = [];

        this._locImgList = [];
        this._locImgNamesList = [];

        this._basePath = "";

        this._emit = new OmyConst.Emit();

        this._canChangaLanguage = true;

        this._isPOEditorEnabled = false;
    }

    initPOEditor(apiToken, key, languages, languageIds, gameKey) {
        this._isPOEditorEnabled = true;
        POEditor.apiToken = apiToken;
        POEditor.key = key;
        POEditor.languages = languages;
        POEditor.languageIds = languageIds;
        POEditor.gameKey = gameKey;
    }

    loadCurrentLanguage(callback, context) {
        POEditor.loadLanguage(Omy.language, callback, context);
    }

    get poEditorEnabled() {
        return this._isPOEditorEnabled;
    }

    /**     * @public     */
    addGraphic(sprite) {
        this._graphic = sprite;
        this._tweenShow = Omy.add.tween(this._graphic, { alpha: 1 }, 0.2, this._lockScreen.bind(this), { paused: true });
        this._tweenHide = Omy.add.tween(this._graphic, { alpha: 0 }, 0.2, this._removeTint.bind(this), { paused: true });
    }

    setLanguageMap(option) {
        this._languageMap = option;
    }

    changeLauguage(newL) {
        this._emit.emit("locUpdateStart");
        Omy.language = newL;

        if (this._graphic) {
            this._graphic.revive();
            this._emit.emit("toggle_tint_work", true);
            Omy.stage.addChild(this._graphic);
            this._graphic.alpha = 0;
            this._tweenShow.restart();
        } else {
            this._lockScreen();
        }

    }

    _lockScreen() {
        Omy.add.timer(0.3, this.startLoading, this);
    }

    _removeTint() {
        if (this._graphic) {
            this._emit.emit("toggle_tint_work", false);
            Omy.stage.removeChild(this._graphic);
            this._graphic.kill();
        }
    }

    startLoading() {
        // AntG.GF.lockRender = true;
        for (let j = 0; j < this._locAtlasNamesList.length; j++) {
            let res = Omy.resources[this._locAtlasNamesList[j]];
            // Omy.log(res);
            if (res.isLoading) {
                res.abort();
            }
            for (let objKey in res.textures) {
                res.textures[objKey].destroy(true);
            }
            delete Omy.resources[this._locAtlasNamesList[j]];
        }

        for (let j = 0; j < this._locImgNamesList.length; j++) {
            let res = Omy.resources[this._locImgNamesList[j]];
            // Omy.log(res);
            if (res.isLoading) {
                res.abort();
            }
            res.texture.destroy(true);
            delete Omy.resources[this._locImgNamesList[j]];
        }
        delete Omy.resources["language"];

        let url;
        let name;
        let i;
        let obj;

        url = Omy.assetsURL + "Atlases/";
        for (i = 0; i < this._locAtlasList.length; i++) {
            obj = this._locAtlasList[i];
            name = obj["nameR"];
            Omy.assets.loadAtlas(obj.name, url + Omy.language + "/" + name);
        }

        url = Omy.assetsURL + "Single/";
        for (i = 0; i < this._locImgList.length; i++) {
            obj = this._locImgList[i];
            name = obj["nameR"];
            Omy.assets.loadImage(obj.name, url + Omy.language + "/" + name);
        }
        Omy.assets.checkLocMap();

        let localLanguage = (this._languageMap) ? this._languageMap[Omy.language] || Omy.language : Omy.language;
        if (this._isPOEditorEnabled) {
            POEditor.loadLanguage(localLanguage, this._loadComplete, this);
        } else {
            Omy.assets.loadLocal("language", this._basePath + "assets/language/" + localLanguage + ".json");
            Omy.loader.load(this._loadComplete.bind(this));
        }
    }

    _loadComplete() {
        Omy.assets.checkCustomChars();
        this._data = Omy.assets.getJSON("language");
        this._emit.emit("locUpdate");
        Omy.game.addNextTickUpdate(() => {
            this._emit.emit("locUpdateEnd");
        }, this);

        // AntG.GF.lockRender = false;
        if (this._tweenHide)
            this._tweenHide.restart();
        else
            this._removeTint();
    }

    updateLocalization(...param) {
        this._data = this._data || {};
        if (param) {
            for (let i = 0; i < param.length; i++) {
                Object.assign(this._data, param[i]);
            }
        }
    }

    addBufferText(saveName, text) {
        if (!this._data) this._data = {};
        this._data[saveName] = text;
    }

    setLoc(data) {
        this._data = data;
    }

    /**
     * Get localized text, replacing @1r, @2r, ... with strings from replacement
     * @param {string} name
     * @param {string[]} replacement
     * @returns {string}
     */
    getText(name, ...replacement) {
        /**
         * Recursive get text
         * @param {Object} data
         * @param {string[]} names
         */
        const getText = (data, names) => {
            const name = names[0];
            const next = names.slice(1);
            return next.length && data[name] ? getText(data[name], next) : data[name];
        };
        let result = "";
        const names = name.split("+");
        names.forEach(n => {
            if (n[0] === "'" && n[n.length - 1] === "'") {
                result += n.slice(1, n.length - 1);
            } else {
                result += getText(this._data, n.split(".")) ?? "!" + n;
            }
        });
        replacement.forEach((str, i) => text.replace("@" + i + "r", str));
        result = StringUtils.replaceAll(result, "\r", "");
        return result;
    }

    addLocAtlas(conf) {
        if (!this._canChangaLanguage) return;
        if (this._locAtlasList.indexOf(conf) !== -1)
            return;

        this._locAtlasList.push(conf);
        this._locAtlasNamesList.push(conf.name);
    }

    removeLocAtlas(confName) {
        if (!this._canChangaLanguage) return;
        let index = this._locAtlasNamesList.indexOf(confName);
        if (index === -1)
            return;

        this._locAtlasList.splice(index, 1);
        this._locAtlasNamesList.splice(index, 1);
    }

    addLocImg(conf) {
        if (!this._canChangaLanguage) return;
        if (this._locImgList.indexOf(conf) !== -1)
            return;

        this._locImgList.push(conf);
        this._locImgNamesList.push(conf.name);
    }

    removeLocImg(confName) {
        if (!this._canChangaLanguage) return;
        let index = this._locImgNamesList.indexOf(confName);
        if (index === -1)
            return;

        this._locImgList.splice(index, 1);
        this._locImgNamesList.splice(index, 1);
    }

    checkLocalisation(name) {
        let answer = this._locAtlasNamesList.indexOf(name) !== -1;
        if (!answer)
            answer = this._locImgNamesList.indexOf(name) !== -1;
        return answer;
    }

    /**     * @public     */
    addUpdate(func, context, once = false) {
        if (!this._canChangaLanguage) return;
        if (once)
            this._emit.once("locUpdate", func, context);
        else
            this._emit.on("locUpdate", func, context);
    }

    /**     * @public     */
    removeUpdate(func, context) {
        if (!this._canChangaLanguage) return;
        this._emit.removeListener("locUpdate", func, context);
    }

    /**     * @public     */
    addUpdateStart(func, context, once = false) {
        if (!this._canChangaLanguage) return;
        if (once)
            this._emit.once("locUpdateStart", func, context);
        else
            this._emit.on("locUpdateStart", func, context);
    }

    /**     * @public     */
    removeUpdateStart(func, context) {
        if (!this._canChangaLanguage) return;
        this._emit.removeListener("locUpdateStart", func, context);
    }

    /**     * @public     */
    addUpdateEnd(func, context, once = false) {
        if (!this._canChangaLanguage) return;
        if (once)
            this._emit.once("locUpdateEnd", func, context);
        else
            this._emit.on("locUpdateEnd", func, context);
    }

    /**     * @public     */
    removeUpdateEnd(func, context) {
        if (!this._canChangaLanguage) return;
        this._emit.removeListener("locUpdateEnd", func, context);
    }

    /**     * @public     */
    addTintWorkCallback(func, context, once = false) {
        if (!this._canChangaLanguage) return;
        if (once)
            this._emit.once("toggle_tint_work", func, context);
        else
            this._emit.on("toggle_tint_work", func, context);
    }

    /**     * @public     */
    removeTintWorkCallback(func, context) {
        if (!this._canChangaLanguage) return;
        this._emit.removeListener("toggle_tint_work", func, context);
    }

    get exists() {
        return this._data != null;
    }

    set canChangaLanguage(value) {
        this._canChangaLanguage = value;
    }

    get canChangaLanguage() {
        return this._canChangaLanguage;
    }

    set basePath(value) {
        this._basePath = value;
    }

    get basePath() {
        return this._basePath;
    }
}
